import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

// CONFIG
import config from '../../../Config';

// COMPONENTS
import Paginator from '../../common/Paginator';
import PurchaseTableRow from './PurchaseTableRow';

const PurchaseTable = ({ list, purchase }) => {
  const [pageNumber, setPageNumber] = useState(1);
  const pageLength = config.defaultPL;

  /*
    Handles the change event when clicking a pagination number
  */
  const changeEvent = (event, value) => {
    setPageNumber(value);
  };

  const generateTableBody = () => {
    return list.map((element, i) => (
      <PurchaseTableRow
        key={`purchase_${i}`}
        purchase={purchase}
        element={element}
      />
    ));
  };

  return (
    <>
      <TableContainer
        sx={{ marginBottom: 4, overflowX: 'auto', width: '100%' }}>
        <Table id="inbox">
          <TableHead>
            <TableRow key="head">
              <TableCell width="70%">
                PrePaid Message bundles available
              </TableCell>
              <TableCell width="30%"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{generateTableBody()}</TableBody>
        </Table>
      </TableContainer>

      <Paginator
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        itemCount={list.length ?? 0}
        changeEvent={changeEvent}
        pageLength={pageLength}
      />
    </>
  );
};

export default PurchaseTable;
